import { format } from "date-fns";

const isSupportedDateInputYear = (year) => {
  return Number.isInteger(year) && year >= 1000 && year <= 9999;
};

export function formarDateTime(date, formatStr = "yyyy-MM-dd hh:mm:ss") {
  return date ? format(date, formatStr) : "";
}

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function decamelize(str, separator) {
  separator = typeof separator === "undefined" ? "_" : separator;
  let asd = str
    .replace(/([a-z\d])([A-Z])/g, "$1" + separator + "$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + separator + "$2")
    .toLowerCase();

  return asd.charAt(0).toUpperCase() + asd.substr(1, asd.length - 1);
}

// Formats date string to "MMM dd, yyyy" format
export const formatDateShort = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  } catch {
    return dateString;
  }
};

// Converts date string to DD/MM/YYYY format for display
export const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return "";
  }
};

// Converts date string to DD-MM-YYYY format for edit-mode display
export const formatDateForEditDisplay = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  } catch {
    return "";
  }
};

// Converts date string to YYYY-MM-DD format for input[type="date"]
export const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  try {
    let dateOnly = dateString.trim();

    // Prefer native parsing for timestamp-like values from the API.
    if (
      /[T:+]/.test(dateOnly) ||
      /^\d{1,2}\/\d{1,2}\/\d{4}\s+\d/.test(dateOnly)
    ) {
      const parsedDate = new Date(dateOnly);

      if (!isNaN(parsedDate.getTime())) {
        const year = parsedDate.getFullYear();

        if (!isSupportedDateInputYear(year)) {
          return "";
        }

        const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
        const day = String(parsedDate.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      }
    }

    if (dateOnly.includes(" ")) {
      dateOnly = dateOnly.split(" ")[0];
    }

    // Handle slash-separated dates, supporting both DD/MM/YYYY and MM/DD/YYYY.
    if (dateOnly.includes("/")) {
      const parts = dateOnly.split("/");

      if (parts.length === 3) {
        const [firstPart, secondPart, year] = parts;

        if (year.length === 4) {
          const firstNumber = Number(firstPart);
          const secondNumber = Number(secondPart);
          const isLikelyDayMonth = firstNumber > 12 || secondNumber <= 12;
          const day = isLikelyDayMonth ? firstPart : secondPart;
          const month = isLikelyDayMonth ? secondPart : firstPart;

          return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
      }
    }
    // Handle DD-MM-YYYY format (with dashes) - common API format
    if (dateOnly.includes("-") && !dateOnly.includes("T")) {
      const parts = dateOnly.split("-");
      if (parts.length === 3) {
        // Check if first part is day (1-31) or year (4 digits)
        if (parts[0].length <= 2 && parts[2].length === 4) {
          // DD-MM-YYYY format
          const [day, month, year] = parts;
          return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        } else if (parts[0].length === 4) {
          // Already YYYY-MM-DD format
          return dateOnly;
        }
      }
    }
    // Handle ISO or other date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    if (!isSupportedDateInputYear(year)) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};
